import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & { title?: string };

const AssetSupportIcon = ({ title, ...props }: Props) => (
  <svg
    viewBox="0 0 21 21"
    width={21}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : true}
    role={title ? 'img' : 'presentation'}
    {...props}
  >
    <path
      d="m19.737 2.713-2.42-2.42a1 1 0 0 0-1.414 0l-4.58 4.58a1 1 0 0 0-.293.707V8a1 1 0 0 0 1 1h2.42a1 1 0 0 0 .707-.293l4.58-4.58a1 1 0 0 0 0-1.414ZM14.037 7H13.03V5.994l3.58-3.58 1.006 1.006L14.037 7ZM17 9.962a1 1 0 0 0-1 1v2.392l-1.48-1.48a2.78 2.78 0 0 0-3.929 0l-.698.697-2.486-2.486a2.777 2.777 0 0 0-3.924 0L2 11.568V5.962a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H3a3.003 3.003 0 0 0-3 3v12a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3v-7a1 1 0 0 0-1-1Zm-14 9a1 1 0 0 1-1-1v-3.566l2.897-2.897a.8.8 0 0 1 1.096 0l3.168 3.167c.009.01.012.022.02.03l4.267 4.266H3Zm13-1a.97.97 0 0 1-.179.537l-4.514-4.514.698-.698a.78.78 0 0 1 1.1 0L16 16.182v1.78Z"
      fill="currentColor"
    />
  </svg>
);

export default AssetSupportIcon;
